<template>
   
  <form @submit.prevent="handleSubmit" id="response_create_form">
    <!-- Response Name -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Response Name <span class="text-danger">*</span></label>
      <input type="text" class="form-control form-control-thin" v-model="form.name" placeholder="Enter response name" required />
    </div>

    <!-- Scoring Checkbox -->
    <div class="mb-3">
      

      <!-- <label class="checkbox-label">
                      <input type="checkbox" v-model="form.enable_scoring" >
                      <span class="checkmark"></span>
                      Enable Scoring
                    </label> -->
    </div>

    <!-- Options -->
    <div class="mb-3">
      <label class="form-label form-label-thin">Options <span class="text-danger">*</span></label>
      <div class="options-container">
        <div v-for="(option, index) in form.options" :key="index" class="option-item">
          <div class="option-row">
            <input 
              type="color" 
              class="color-picker" 
              v-model="option.bg_color" 
            />
            <input 
              type="text" 
              class="form-control form-control-thin form-control-thin-name" 
              v-model="option.name" 
              :placeholder="`Option ${index + 1}`"
              required
            />
            <input 
              v-if="form.enable_scoring"
              type="number" 
              class="form-control form-control-thin score-input" 
              v-model="option.score" 
              placeholder="Score (1-100)"
              min="0"
              max="100"
            />
            <button type="button" class="btn-remove" @click="removeOption(index)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="text-end">
          <button type="button" class="btn btn-light py-2 btn-sm" @click="addOption">
        + Add Option
      </button>
      </div>
      
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-outline-danger btn-sm hover-white" @click="close">
        <i class="fa fa-times"></i> Cancel
      </button>
      <button type="submit" class="btn btn-primary text-light hover-white btn-md form-submit-btn" :disabled="submitting">
        <i class="fa fa-save"></i> {{ submitting ? 'Creating...' : 'Create Response' }}
      </button>
    </div>
  </form>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'

export default {
  name: 'CreateResponse',
  
  emits: ['created', 'close'],
//   receive prop template
  props: {
    template: {
      type: Object,
      required: true
    },
    responses: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      form: {
        name: '',
        template_id: this.template.external_id,
        enable_scoring: false,
        options: [
          { name: '', bg_color: '#667eea', score: null }
        ]
      },
      submitting: false,
    }
  },
  methods: {
    addOption() {
      this.form.options.push({
        name: '',
        bg_color: '#667eea',
        score: null
      })
    },
    
    removeOption(index) {
      if (this.form.options.length > 1) {
        this.form.options.splice(index, 1)
      }
    },
    
    async handleSubmit() {
      this.submitting = true

      const result = await form_api_submit({
        url: `template/builder/response/create`,
        method: 'POST',
        data: this.form,
        // take_form_data: true,
        curr_form_id: '#response_create_form',
      })

      if (result.success) {
        this.responses.push(result.data) // add new response to responses array
        this.$emit('created', result.data)
        this.close()
        this.resetForm()
      }

      this.submitting = false
    },

    close() {
      this.$emit('close')
    },

    resetForm() {
      this.form = {
        name: '',
        enable_scoring: false,
        options: [
          { name: '', bg_color: '#667eea', score: null }
        ]
      }
    }
  }
}
</script>

<style scoped>
.options-container {
  margin-bottom: 10px;
}

.option-item {
  margin-bottom: 10px;
}

.option-row {
  display: flex;
  gap: 10px;
  align-items: center;
}

.option-row .form-control-thin {
  flex: 1;
}
.option-row .form-control-thin-name {
  flex: 2;
}

.color-picker {
  width: 33px;
  height: 33px;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  padding: 0;
  overflow: hidden;
  flex-shrink: 0;
}

.color-picker::-webkit-color-swatch-wrapper {
  padding: 0;
}

.color-picker::-webkit-color-swatch {
  border: none;
  border-radius: 50%;
}

.score-input {
  width: 80px;
}

.btn-remove {
  background: none;
  border: none;
  cursor: pointer;
  color: #dc3545;
  padding: 6px;
}

.btn-add-option {
  background: none;
  border: 1px dashed #ddd;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}
</style>